import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message, InputNumber } from "antd";

const ProductModelForm = ({ open, setOpen, data, isEdit, onSubmit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      if (isEdit && data) {
        form.setFieldsValue(data);
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, data, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (isEdit) {
        await onSubmit({ ...data, ...values });
      } else {
        await onSubmit(values);
      }
      form.resetFields();
      setOpen(false);
    } catch (err) {
      console.error(err);
      message.error("Failed to submit the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={isEdit ? "Edit Product Model" : "Add Product Model"}
      width={450}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        {/* Product Model Number */}
        <Form.Item
          label="Product Model Number"
          name="productModelNumber"
          rules={[
            { required: true, message: "Please enter product model number." },
          ]}
        >
          <Input placeholder="Enter product model number" />
        </Form.Item>

        {/* Cost Price */}
        <Form.Item
          label="Cost Price"
          name="costPrice"
          rules={[{ required: true, message: "Please enter cost price." }]}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            placeholder="Enter cost price"
          />
        </Form.Item>

        {/* Selling Price */}
        <Form.Item
          label="Selling Price"
          name="sellingPrice"
          rules={[{ required: true, message: "Please enter selling price." }]}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            placeholder="Enter selling price"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" block htmlType="submit" loading={isLoading}>
            {isEdit ? "Update Product Model" : "Add Product Model"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default ProductModelForm;
